import { volunteerType } from '../../types';
import * as utils from '../utils';
import type { IResponse } from './election';

export interface ICreateVolunteer {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	stateId: number;
	nin: string;
	lgaId: number;
	lgaName?: string;
	wardId: number;
	wardName?: string;
	pollingUnitId: number;
}

export const create_Volunteer = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: ICreateVolunteer;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Volunteer',
			header: utils.header(),
			data,
		},
		actionType: volunteerType.create_Volunteer,
		onFailure,
		onSuccess,
		auth: true,
	});

// Body of POST /api/v1/Auth/agent-onboarding. Built by
// src/components/pages/onboarding/roles.ts (`buildAgentOnboardingBody`).
export interface IOnboardVolunteerBody {
	volunteerId: number;
	accountName: string;
	accountNumber: string;
	bankName: string;
	governmentDocument: string;
	profilePhoto: string;
	votersCardId: string;
	// null when the live-face phase ended in manual review (no face enrolled).
	faceId: string | null;
	latitude: number | null;
	longitude: number | null;
	deviceInfo: object | null;
	consentTimestamp?: string;
	consentIp?: string | null;
	consentFingerprint?: string | null;
	marketingOptIn?: boolean;
	needsManualReview?: boolean;
	// One entry per acknowledged legal document, echoing the active document
	// verbatim (see src/lib/legal-api.ts). The contentHash pins the exact text
	// the agent saw — never recompute or omit it.
	consents?: { documentType: number; version: string | null; contentHash: string | null }[];
}

export const onboard_Volunteer = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IOnboardVolunteerBody;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Auth/agent-onboarding',
			header: utils.header(),
			data,
		},
		actionType: volunteerType.onboard_Volunteer,
		onFailure,
		onSuccess,
		auth: true,
	});
